import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const AdminSection = styled.div`
  padding: ${({ theme }) => theme.spaces.xl}rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.backgroundLila};
  margin-bottom: ${({ theme }) => theme.spaces.xl}rem;
  width: 100%;
`;

export const TenantRow = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spaces.s}rem ${({ theme }) => theme.spaces.m}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  cursor: pointer;
  transition: background 0.2s;
  background: ${({ $selected, theme }) =>
    $selected ? theme.colors.garnet + '20' : 'transparent'};
  border: 0.1rem solid ${({ $selected, theme }) =>
    $selected ? theme.colors.garnet : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.garnet + '10'};
  }
`;

export const TenantInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const StatusBadge = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 1.2rem;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.greenTransparent : 'rgba(220, 53, 69, 0.1)'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.green : '#dc3545'};
  border: 1px solid ${({ $active, theme }) =>
    $active ? theme.colors.green : '#dc3545'};
`;

export const TenantHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.m}rem;
  margin-bottom: ${({ theme }) => theme.spaces.m}rem;
`;

export const FlagRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spaces.s}rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight}20;
  gap: ${({ theme }) => theme.spaces.m}rem;

  &:last-child {
    border-bottom: none;
  }
`;

export const FlagInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;
`;

export const FlagActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.l}rem;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const FlagEditFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.s}rem;
  width: 100%;
  max-width: 60rem;
`;

export const OriginBadge = styled.span<{ $override?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.8rem;
  border-radius: 1.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${({ $override }) =>
    $override ? 'rgba(79, 81, 140, 0.12)' : 'rgba(104, 104, 144, 0.08)'};
  color: ${({ $override }) => ($override ? '#4F518C' : '#686890')};
  border: 1px solid ${({ $override }) => ($override ? '#4F518C' : '#686890')};
`;
